import { render, staticRenderFns } from "./MedicationTable.vue?vue&type=template&id=2284779a&scoped=true"
import script from "./MedicationTable.vue?vue&type=script&lang=js"
export * from "./MedicationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284779a",
  null
  
)

export default component.exports